import { Link } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

export default function TermsAndConditionsLink() {
  return (
    <Link to="#terms-and-conditions">
      <T>Terms and Conditions</T>
    </Link>
  );
}
